import { LoiCoOwnersPreview, LoiPreparationRequest } from './models/loi-co-owners-preview.model';

const okHttpStatus = 200;
const defaultRequestError = 'The request failed. Please try again.';

interface LoiPreparationResponse<T> {
    status?: number;
    data?: T;
    response?: { data?: { title?: string } };
}

const getDataOrThrow = <T>(response: LoiPreparationResponse<T>): T => {
    if (response?.status !== okHttpStatus || response.data === undefined) {
        throw new Error(response?.response?.data?.title || defaultRequestError);
    }
    return response.data;
};

export async function fetchLoiPreparationUrl(
    axios: { post: (url: string, data: unknown, config?: { params?: Record<string, unknown> }) => Promise<LoiPreparationResponse<{ prepareUrl: string }>> },
    engagementId: number,
    eventId: string,
    buyerId: number,
    request: LoiPreparationRequest,
): Promise<string> {
    const response = await axios.post(
        `/api/Marketplace/${engagementId}/LoiPreparation/PrepareUrl`,
        request,
        { params: { eventId, buyerId } },
    );
    return getDataOrThrow(response).prepareUrl;
}

export async function fetchLoiPreparationStatus(
    axios: { get: (url: string, config?: { params?: Record<string, unknown> }) => Promise<LoiPreparationResponse<{ isPrepared: boolean }>> },
    engagementId: number,
    eventId: string,
    buyerId: number,
): Promise<boolean> {
    const response = await axios.get(
        `/api/Marketplace/${engagementId}/LoiPreparation/Status`,
        { params: { eventId, buyerId } },
    );
    return getDataOrThrow(response).isPrepared;
}

export async function fetchLoiCoOwnersPreview(
    axios: { get: (url: string, config?: { params?: Record<string, unknown> }) => Promise<LoiPreparationResponse<LoiCoOwnersPreview>> },
    engagementId: number,
    eventId: string,
    buyerId: number,
): Promise<LoiCoOwnersPreview> {
    const response = await axios.get(
        `/api/Marketplace/${engagementId}/LoiPreparation/CoOwners`,
        { params: { eventId, buyerId } },
    );
    return getDataOrThrow(response);
}

export async function uploadLoiExecutedDocument(
    axios: { post: (url: string, data: unknown, config?: { params?: Record<string, unknown>; headers?: Record<string, string> }) => Promise<LoiPreparationResponse<unknown>> },
    engagementId: number,
    buyerId: number,
    file: File,
): Promise<void> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(
        `/api/Marketplace/${engagementId}/LoiPreparation/UploadExecutedDocument`,
        formData,
        {
            params: { buyerId },
            headers: { 'Content-Type': 'multipart/form-data' },
        },
    );
    getDataOrThrow(response);
}
